module.exports = __webpack_public_path__ + "img/a4.de548aa8.jpg";